<template>
  <div>
    <div class="ibox">
      <div class="ibox-title">
        <h5>Latest Content</h5>
        <div class="ibox-tools pull-right">
          <a class="collapse-link">
            <i class="fa fa-chevron-up"></i>
          </a>
        </div>
      </div>
      <div class="ibox-content">
        <table class="table table-hover" id="money-sites">
          <thead>
          <tr>
            <th>Post</th>
            <th>Site</th>
            <th>Group</th>
            <th>Created</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="post in posts" :key="post.id">
            <td :title="post.title">
              <span class="label label-success">{{ post.language }}</span>
              {{ shorten(post.title, 30) }}
              <a :href="post.url" target="_blank"><i class="fa fa-external-link"></i></a>
            </td>
            <td>
              <router-link :to="'/pbn/' + post.pbn.punyDomain">{{ post.pbn.domain }}</router-link>
              <a :href="'https://' + post.pbn.domain" target="_blank"><i class="fa fa-external-link"></i></a>
            </td>
            <td>{{ post.pbn.group ? post.pbn.group.name : '/' }}</td>
            <td>{{ post.created.date | moment('from') }}</td>
            <td></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import { Query, Values } from '../../../../../mixins/helperMixin'

export default {
  data () {
    return {
      posts: []
    }
  },
  mixins: [Query, Values],
  mounted () {
    this.loadContent()
  },
  watch: {
    filters: function () {
      this.loadContent()
    }
  },
  computed: {
    ...mapGetters({
      filters: 'getViewFilters'
    })
  },
  methods: {
    loadContent () {
      axios.get('/posts?orderBy=created&orderDir=DESC&limit=10' + this.buildQuery(this.filters))
        .then(r => {
          this.posts = r.data.data
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Dashboard/Overview/LatestContent.vue